/*
  Fit Finder A/B/C test (round 2) — sticky 1/3 · 1/3 · 1/3 traffic split.

  Runs only on /pages/fit-finder (the old control page), before the finder
  section itself renders (see the fit-finder-variant-split section, ordered
  first in templates/page.finder.json). Every visitor is assigned once to one
  of three arms and redirected to that arm's page:

    v2_challenger  ->  /pages/fit-finder-v2   (A, baseline)
    v3_cta         ->  /pages/fit-finder-v3   (B, new results + inline device/cable)
    c_assistant    ->  /pages/fit-assist      (C, AI assistant)

  The old control (v1_control) is retired: nobody is assigned to it and nobody
  stays on /pages/fit-finder.

  Round 1 stored its assignment under dongar_ff_variant. Round 2 deliberately
  uses a NEW key, so every visitor, including everyone previously in the old
  control or challenger, gets a fresh random draw. The old key is ignored (and
  left alone). The assignment is persisted for 90 days, so a visitor who comes
  back keeps the same arm. Query string and hash are preserved on the redirect.

  Assistant hand-off: the assistant widget marks the Fit Finder links it gives out
  with ?src=assistant. A visitor assigned to the assistant (arm C) who follows one
  is sent to the regular finder (arm A's page) with the marker kept, so those
  visits can be counted separately and left out of arm A's numbers; their stored
  arm stays C. For any other arm the marker is dropped and they go to their own page.

  Fails safe: if storage is unavailable the visitor can't be kept in one arm
  across visits, so they are sent to arm A (the baseline) instead of being
  re-rolled on every load.
*/
(function () {
  'use strict';

  var KEY = 'dongar_ff_variant_r2', TS_KEY = 'dongar_ff_variant_r2_ts';
  var MAX_AGE_MS = 90 * 24 * 60 * 60 * 1000;
  var ARMS = [
    { id: 'v2_challenger', path: '/pages/fit-finder-v2' },
    { id: 'v3_cta',        path: '/pages/fit-finder-v3' },
    { id: 'c_assistant',   path: '/pages/fit-assist' }
  ];

  function armById(id) {
    for (var i = 0; i < ARMS.length; i++) if (ARMS[i].id === id) return ARMS[i];
    return null;
  }

  var arm = null;
  try {
    var now = Date.now();
    var storedTs = parseInt(localStorage.getItem(TS_KEY) || '0', 10);
    arm = armById(localStorage.getItem(KEY));

    if (!arm || !storedTs || (now - storedTs) > MAX_AGE_MS) {
      arm = ARMS[Math.min(ARMS.length - 1, Math.floor(Math.random() * ARMS.length))];
      localStorage.setItem(KEY, arm.id);
      localStorage.setItem(TS_KEY, String(now));
    }
  } catch (e) {
    arm = null; /* storage blocked/unavailable */
  }
  if (!arm) arm = ARMS[0];

  try {
    var search = window.location.search || '';
    var fromAssistant = /[?&]src=assistant(&|$)/i.test(search);
    var dest = arm;
    if (fromAssistant) {
      if (arm.id === 'c_assistant') dest = ARMS[0]; /* sent here by the assistant: show the real finder */
      else search = search.replace(/([?&])src=assistant(&|$)/i, function (m, pre, post) { return post ? pre : ''; });
    }
    window.location.replace(dest.path + (search === '?' ? '' : search) + (window.location.hash || ''));
  } catch (e) { /* stay on the page rather than error */ }
})();
